import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SurveyTimelineBox from './SurveyTimelineBox';
import { PreviewButton } from '../../../../components/button/ActionButton';
import SurveyRespondentDetailMetadata from './SurveyRespondentDetailMetadata';
import { Gr8piFormattedDate } from '../../../../components/Gr8piFormattedDateTime';
import { getUserLanguage } from '../../../../utils/LanguageUtil';

class SurveyRespondentDetailComponent extends Component {
  render() {
    const {
      sendInviteEmail,
      sendRemindingEmail,
      currentAccount,
      previewSurvey,
      isEmailSending,
      availableTranslations,
      surveyRespondent,
    } = this.props;
    const {
      expiredOn, createdOn, locale, respondent, survey,
    } = surveyRespondent;

    const translatedLocale = getUserLanguage(locale, availableTranslations);
    return (
      <div>
        <SurveyRespondentDetailMetadata respondent={respondent} survey={survey} currentAccount={currentAccount} />
        <div className="wrapper">
          <h1 className="border-bottom no-margin clearfix">
            <div className="row">
              <div className="col-md-7">
                {respondent.firstName}
                {' '}
                {respondent.lastName}
              </div>
              <div className="col-md-5">
                {// isAuthorizedUser(AuthorizedUser.TESTER)
                false && <PreviewButton position="left" onClick={previewSurvey} textId="preview" />}
              </div>
            </div>
          </h1>
          <div className="row">
            <div className="col-md-7">
              <div>
                <h2 className="text-muted">
                  <FormattedMessage id="survey" defaultMessage="Survey" />
                  :
                  <strong>{survey.name}</strong>
                </h2>
                <div className="survey-details">
                  <div>
                    <FormattedMessage id="attrs.language" defaultMessage="Language" />
                    :
                  </div>
                  <div>{translatedLocale && <span>{translatedLocale.name}</span>}</div>
                </div>
                <div className="survey-details">
                  <div>
                    <FormattedMessage id="attrs.created" defaultMessage="Created" />
                    :
                  </div>
                  <div>
                    <span>
                      <Gr8piFormattedDate dateValue={createdOn} />
                    </span>
                  </div>
                </div>
                <div className="survey-details">
                  <div>
                    <FormattedMessage id="assessment.expiresOn" defaultMessage="Expires on" />
                    :
                  </div>
                  <div>
                    <span>{expiredOn && <Gr8piFormattedDate dateValue={expiredOn} />}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <SurveyTimelineBox
                sendInviteEmail={sendInviteEmail}
                sendRemindingEmail={sendRemindingEmail}
                surveyData={surveyRespondent}
                isEmailSending={isEmailSending}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SurveyRespondentDetailComponent.propTypes = {
  sendInviteEmail: PropTypes.func.isRequired,
  sendRemindingEmail: PropTypes.func.isRequired,
  currentAccount: PropTypes.string.isRequired,
  previewSurvey: PropTypes.func.isRequired,
  isEmailSending: PropTypes.bool.isRequired,
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
  surveyRespondent: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default SurveyRespondentDetailComponent;
